import { isRTL } from '@ms/yammer-i18n';

import { useI18nStore } from '../state/i18nStore';

type UseCurrentLocale = () => string;
export const useCurrentLocale: UseCurrentLocale = () => useI18nStore((state) => state.currentLocale);

type UseRequestedLocale = () => string;
export const useRequestedLocale: UseRequestedLocale = () => useI18nStore((state) => state.requestedLocale);

type UseIsCurrentLocaleRTL = () => boolean;
export const useIsCurrentLocaleRTL: UseIsCurrentLocaleRTL = () => useI18nStore((state) => isRTL(state.currentLocale));

type CurrentLocaleDirection = () => 'rtl' | 'ltr';
export const useCurrentLocaleDirection: CurrentLocaleDirection = () => {
  const isRTL = useIsCurrentLocaleRTL();

  return isRTL ? 'rtl' : 'ltr';
};
